module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[81]446.77bffea.woff2";